import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const PARTNERS_MEET_MORE_COMPANIES = [
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/1.svg"
        alt="American Family Insurance"
      />
    ),
    href: 'https://www.amfam.com/',
    key: 1,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/2.svg"
        alt="Crawford"
      />
    ),
    href: 'https://hover.to/blog/qa-with-ken-tolson-crawford-company/',
    key: 2,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/3.svg"
        alt="Fourseventy Claim Management"
      />
    ),
    href: 'http://470claims.com/blog/2020/04/03/ep-69-hovers-ceo-founder-a-j-altman/',
    key: 3,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/4.svg"
        alt="Hancock claims"
      />
    ),
    href: 'https://www.hancockclaims.com/press-release-hover',
    key: 4,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/5.svg"
        alt="Nationwide"
      />
    ),
    href: 'https://news.nationwide.com/nationwide-invests-in-hover/',
    key: 6,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/6.svg"
        alt="Pacesetter claims service"
      />
    ),
    href: 'https://pacesetterclaims.com/',
    key: 7,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/7.svg"
        alt="StateFarm"
      />
    ),
    href: 'https://www.statefarm.com/',
    key: 8,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/8.svg"
        alt="Travelers"
      />
    ),
    href: 'https://www.travelers.com/',
    key: 9,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/meet-more/9.svg"
        alt="U.S. Adjusting Services"
      />
    ),
    href: 'https://www.usadjustingservices.net/',
    key: 10,
  },
];

export const PARTNERS_MEET_MANUFACTURERS = [
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/1.svg" alt="" />
    ),
    href: 'https://abcseamless.com/abc-design-tool',
    key: 1,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/2.svg" alt="" />
    ),
    href: 'https://www.alside.com/professionals/support-programs/alside-jobsight-3d/',
    key: 2,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/3.svg" alt="" />
    ),
    href: 'https://www.atlasroofing.com/',
    key: 3,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/4.png" alt="" />
    ),
    href: 'https://go.becn.com/l/269902/2019-05-31/7qgb6',
    key: 4,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/5.svg" alt="" />
    ),
    href: 'https://help.hover.to/en/articles/4320999-belgard-contractor-programs-app-integration-overview',
    key: 5,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/6.svg" alt="" />
    ),
    href: 'https://www.certainteed.com/HOVER/',
    key: 6,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/7.svg" alt="" />
    ),
    href: 'https://www.drexmet.com/',
    key: 7,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/8.svg" alt="" />
    ),
    href: 'https://gaf.hover.to/',
    key: 8,
  },
  {
    logo: (
      <StaticImage src="../assets/images/partners/manufacturers/9.svg" alt="" />
    ),
    href: 'https://www.iko.com/na/roofpro-intro-page/',
    key: 9,
  },
  {
    logo: <StaticImage src="../assets/images/james_hardie_logo.png" alt="" />,
    href: 'https://www.jameshardie.com/about-us/news/new-james-hardie-app-generates-accurate-home-measu',
    key: 10,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/11.svg"
        alt=""
      />
    ),
    href: 'https://www.kpvinylsiding.com/',
    key: 11,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/12.svg"
        alt=""
      />
    ),
    href: 'https://lansingbp.com/',
    key: 12,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/13.svg"
        alt=""
      />
    ),
    href: 'https://hover.to/blog/hover-lp-partner-bring-lp-smartside-products-exterior-contractors-via-hover-platform/',
    key: 13,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/14.svg"
        alt=""
      />
    ),
    href: 'https://malarkeyroofing.com/',
    key: 14,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/15.svg"
        alt=""
      />
    ),
    href: 'https://www.norandex.com/products/vinyl-siding/',
    key: 15,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/16.svg"
        alt=""
      />
    ),
    href: 'https://www.owenscorning.com/en-us',
    key: 16,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/17.svg"
        alt=""
      />
    ),
    href: 'https://www.plygem.com/siding/for-siding-pros/ply-gem-hover/',
    key: 17,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/18.svg"
        alt=""
      />
    ),
    href: 'https://www.royalbuildingproducts.com/',
    key: 18,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/19.svg"
        alt=""
      />
    ),
    href: 'https://hover.to/blog/webinar-recap-hover-x-srs-distribution/',
    key: 19,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/20.svg"
        alt=""
      />
    ),
    href: 'https://www.tamko.com/about/media-center/news-releases/post/2018/01/08/visualize-your-home-with-a-tamko-roof-on-hover',
    key: 20,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/21.svg"
        alt=""
      />
    ),
    href: 'https://vicwest.com/',
    key: 21,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/manufacturers/22.svg"
        alt=""
      />
    ),
    href: 'https://blog.wimsattdirect.com/wimsattdirect-now-works-with-hover',
    key: 22,
  },
  {
    logo: <StaticImage src="../assets/images/abc_logo.png" alt="" />,
    href: 'https://www.abcsupply.com/contractor-center/myabcsupply/',
    key: 23,
  },
];

export const PARTNERS_INTEGRATIONS = [
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/1.svg"
        alt="Accurence"
      />
    ),
    href: 'https://accurence.com/',
    key: 1,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/2.svg"
        alt="Claims Assist"
      />
    ),
    href: 'https://www.claimassist.com/',
    key: 2,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/3.png"
        alt="CompanyCam"
      />
    ),
    href: 'https://help.hover.to/en/articles/2599446-companycam-integration-overview',
    key: 3,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/4.svg"
        alt="CoreLogic"
      />
    ),
    href: 'https://www.corelogic.com/news/corelogic-integrates-hover-property-measurement-and-3d-technology-into-underwriting-platform.aspx',
    key: 4,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/5.svg"
        alt="FileTrac"
      />
    ),
    href: 'https://help.hover.to/en/articles/4321116-filetrac-integration-overview',
    key: 5,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/6.svg"
        alt="GAF Project"
      />
    ),
    href: 'https://www.gaf.com/en-us/project',
    key: 6,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/7.svg"
        alt="Hatch"
      />
    ),
    href: 'https://www.usehatchapp.com/hover',
    key: 7,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/8.svg"
        alt="improveit 360"
      />
    ),
    href: 'https://www.improveit360.com/',
    key: 8,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/9.svg"
        alt="JobNimbus"
      />
    ),
    href: 'https://help.hover.to/en/articles/2599470-jobnimbus-integration-overview',
    key: 9,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/10.svg"
        alt="JobProgress"
      />
    ),
    href: 'https://help.hover.to/en/articles/3088292-jobprogress-integration-overview',
    key: 10,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/11.svg"
        alt="Leap"
      />
    ),
    href: 'https://help.hover.to/en/articles/2599463-leap-integration-overview',
    key: 11,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/12.svg"
        alt="Mosaic"
      />
    ),
    href: 'https://partner.joinmosaic.com/?ref=hover19',
    key: 12,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/13.svg"
        alt="One Click Contractor"
      />
    ),
    href: 'https://help.hover.to/en/articles/3088554-one-click-contractor-integration-overview',
    key: 13,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/14.svg"
        alt="OnSeen"
      />
    ),
    href: 'https://www.onseen.com/liveclaims/',
    key: 14,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/15.svg"
        alt="Restoration AI"
      />
    ),
    href: 'https://help.hover.to/en/articles/3742914-restoration-ai-integration-overview',
    key: 15,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/16.svg"
        alt="SalesRabbit"
      />
    ),
    href: 'https://help.hover.to/en/articles/3991082-zapier-integration-overview',
    key: 16,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/17.svg"
        alt="Symbility"
      />
    ),
    href: 'https://help.hover.to/en/articles/2599387-symbility-integration-overview',
    key: 17,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/18.svg"
        alt="Virtual Claims Adjuster"
      />
    ),
    href: 'https://www.virtualclaimsadjuster.com/',
    key: 18,
  },
  {
    logo: (
      <StaticImage
        src="../assets/images/partners/integrations/19.svg"
        alt="Zapier"
      />
    ),
    href: 'https://help.hover.to/en/articles/3991082-zapier-integration-overview',
    key: 19,
  },
];
